// i18n area 'cluster' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.de-DE.meta.json.
import type { enUS } from './cluster'

export const deDE: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garantiezugänge',
      subtitle: 'Die Servicetür des Knotens: der Nur-Lese-Zugang mit temporärem Passwort und das Notfallkonto mit dem Tresor-Passwort',
      readOnlyTitle: 'Nur-Lese-Zugang (trantor)',
      stateNone: 'geschlossen',
      stateGranted: 'offen',
      stateGrantedPending: 'gewährt — wird auf dem Knoten angewendet',
      grantedBy: 'Gewährt von',
      grantedAt: 'Gewährt am',
      expiresAt: 'Läuft ab am',
      reason: 'Grund',
      endedAt: 'Geschlossen',
      endedReason: {
        revoked: 'widerrufen',
        expired: 'abgelaufen (TTL)',
        reboot: 'Neustart des Knotens',
        failed: 'nicht angewendet (Task fehlgeschlagen)'
      },
      grant: 'Nur-Lese-Zugang gewähren…',
      grantTitle: 'Nur-Lese-Zugang gewähren',
      grantSubmit: 'Gewähren',
      grantError: 'Die Gewährung wurde abgelehnt',
      grantConfirm: 'TVirt erzeugt ein temporäres Passwort für den Systembenutzer «trantor» (nur lesen: Journal und Diagnose, kein sudo) und setzt es per Task auf dem Knoten. Das Passwort wird EIN einziges Mal angezeigt, bei der Bestätigung; es endet mit dem Ablauf, dem Widerruf oder dem nächsten Neustart des Knotens.',
      reasonLabel: 'Grund',
      reasonHint: 'Warum Sie die Tür öffnen: steht in der Gewährung, im Audit und im Journal',
      ttlLabel: 'Dauer',
      ttlHours: '{n} h',
      revoke: 'Nur-Lese-Zugang widerrufen…',
      revokeTitle: 'Nur-Lese-Zugang widerrufen',
      revokeSubmit: 'Widerrufen',
      revokeError: 'Der Widerruf wurde abgelehnt',
      revokeConfirm: 'Die Gewährung endet sofort und ein Task sperrt den Benutzer «trantor» auf dem Knoten wieder: Das temporäre Passwort gilt nicht mehr.',
      passwordTitle: 'Nur-Lese-Passwort',
      passwordOnce: 'Dieses Passwort wird EIN einziges Mal angezeigt: Kopieren Sie es jetzt. Es wird nirgends gespeichert und kann nicht erneut gelesen werden — wenn Sie es verlieren, gewähren Sie erneut.',
      passwordUser: 'Benutzer',
      passwordLabel: 'Passwort',
      passwordHint: 'Gültig bis {until} oder bis zum nächsten Neustart des Knotens; nutzbar, sobald der Gewährungs-Task abgeschlossen ist. Zugang: ssh trantor@<Adresse des Knotens>.',
      emergencyTitle: 'Letzter Notfallzugang (trantor-emergency)',
      lastLogin: '{time} über {via} von {from}',
      lastLoginNone: 'keiner beobachtet',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'Konsole',
        sudo: 'sudo',
        unknown: 'unbekannt'
      },
      emergencyHint: 'Das Notfallkonto «trantor-emergency» (volles sudo) ist stets aktiv mit dem bei der Installation des Knotens erzeugten und im Tresor verwahrten Passwort: TVirt kennt es nicht, rotiert es nicht und stellt es nicht wieder her. Jede Anmeldung wird hier und im Ereignisjournal gemeldet.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Knoten-Firewall',
      subtitle: 'Die Haltung des nftables-Rulesets, das jeder Knoten auf sich selbst anwendet — die einzige Firewall eines Knotens (firewalld ist deaktiviert)',
      modeLabel: 'Haltung',
      mode: {
        disabled: 'Deaktiviert — kein Ruleset auf den Knoten',
        permissive: 'Permissiv — zählt und protokolliert, verwirft nichts',
        enforced: 'Erzwungen — nur das abgeleitete Register kommt herein'
      },
      hint: {
        disabled: 'Wie heute: Die Knoten tragen kein Ruleset. Wechseln Sie auf permissiv, um zu LESEN, was verworfen würde, bevor es verworfen wird.',
        permissive: 'Jeder Knoten wendet sein abgeleitetes Ruleset mit policy accept an: Was der erzwungene Modus verwerfen würde, wird gezählt und protokolliert (Journal-Präfix «tvirt-node would-drop:»). Nichts wird blockiert.',
        enforced: 'Jeder Knoten wendet sein abgeleitetes Ruleset mit policy drop an: ssh und API von überall, store / live migration / overlay / Ceph nur von den Mitgliedern, die Listener der Netzwerkdienste aus dem bedienten Netz. Jeder Wechsel ist ein Apply mit Bestätigung — ein Knoten, der nicht bestätigen kann, rollt von selbst zurück.'
      },
      confirmTitle: 'Die Knoten-Firewall erzwingen?',
      confirmBody: 'Jeder Knoten wendet das Ruleset mit Bestätigung an: Er prüft Backend, Store und ssh durch die neuen Regeln innerhalb der Frist und bestätigt — andernfalls rollt er von selbst auf das vorherige Ruleset zurück. Lesen Sie zuerst die Zähler des permissiven Modus auf den Knoten.',
      confirmSubmit: 'Erzwingen',
      confirmCancel: 'Abbrechen',
      lensTitle: 'Firewall des Knotens',
      loadError: 'Die Firewall-Linse des Knotens konnte nicht geladen werden',
      noReport: 'Noch kein Firewall-Bericht von diesem Knoten — der Worker meldet beim nächsten Pass',
      firewalldActive: 'Auf diesem Knoten läuft firewalld: Die Knoten-Firewall weigert sich, neben ihm zu greifen (firewalld maskieren)',
      conditionUnconfirmed: 'Noch kein bestätigtes Ruleset — der Knoten ist offen',
      conditionRolledBack: 'Der letzte Apply ist zurückgerollt — dieselbe Generation wird nicht erneut versucht, bis sich das Register ändert oder die Haltung erneut gewechselt wird',
      lastError: 'Letzter Fehler',
      posture: 'Haltung',
      observedAt: 'Beobachtet',
      desiredGeneration: 'Gewünschte Generation',
      componentTitle: 'Knotenkomponente',
      componentSubtitle: 'tvirt-node-firewall — wendet beim Boot das bestätigte Ruleset an, rollt ein unbestätigtes von selbst zurück',
      componentAbsent: 'Die Komponente hat noch nicht gemeldet',
      phase: 'Phase',
      phases: {
        none: 'Nie angewendet',
        applied: 'Angewendet — wartet auf Bestätigung',
        confirmed: 'Bestätigt',
        rolledBack: 'Zurückgerollt'
      },
      generation: 'Generation',
      appliedAt: 'Angewendet am',
      confirmedAt: 'Bestätigt am',
      deadline: 'Rollback-Frist',
      lastRollback: 'Letzter Rollback',
      registryTitle: 'Abgeleitetes Register',
      registrySubtitle: 'Die Ports, die dieser Knoten öffnet, nach Klasse und Herkunft — aus dem Cluster abgeleitet, nie von Hand bearbeitet',
      registryEmpty: 'Nichts abgeleitet — Haltung deaktiviert ohne bestätigtes Ruleset, oder noch kein Bericht',
      colClass: 'Klasse',
      colPort: 'Port',
      colSource: 'Quelle',
      colOrigin: 'Herkunft',
      classes: {
        public: 'Öffentlich',
        internode: 'Knotenübergreifend',
        tenant: 'Tenant'
      },
      sourceMembers: 'nur die Mitglieder',
      sourceAnywhere: 'überall',
      sourceBridge: 'auf {iface}'
    },
    derivationDerived: 'abgeleitet',
    derivationDiverged: 'abgewichen',
    derivationDerivedTip: 'Das Netzwerkdokument ist von Fabric {fabric} ABGELEITET und deckt sich noch mit dem Render auf den aktuellen Eingaben — Klick für den Ableitungsplan.',
    derivationDivergedTip: 'Die Ableitung von Fabric {fabric} hat sich nach dem letzten Apply geändert (Fabric, Verkabelung, Rollen oder Referenzen) — Klick für das ausstehende Diff.',
    derivationRetiring: {
      one: '{n} Adresse läuft leer',
      other: '{n} Adressen laufen leer'
    },
    standaloneHint: 'Dieser Knoten hat keinen Cluster: Er wurde noch nicht installiert. Cluster werden bei der Installation erstellt ODER gejoint — der aus der Server-Tabelle eines Mitglieds erzeugte Token wird dem Installer übergeben (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Deine Berechtigungen decken einen Scope ab, nicht den gesamten Cluster: Das Flotteninventar — Knoten, Einstellungen und Geräte — sehen nur Cluster-Administratoren.',
    phaseReady: 'Bereit',
    phaseForming: 'In Bildung',
    storeMembers: 'Store-Mitglieder',
    watermark: 'Konvergenzschwelle',
    configGeneration: 'Config-Generation',
    converged: 'konvergiert',
    behind: 'im Rückstand — {m} / {n}',
    revision: 'Revision',
    rolesTitle: 'Netzwerkrollen',
    rolesSubtitle: 'Adressen je Mitglied für jede Traffic-Klasse — die Konnektivität selbst lebt im Host-Netzwerk',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'erbt Management',
    settingsTitle: 'Einstellungen',
    settingsSubtitle: 'Clusterweite Sicherheits-Policy — von jedem Knoten aus seiner lokalen Replik ausgewertet',
    taskRetentionTitle: 'Task-Aufbewahrung',
    taskRetentionSubtitle: 'Einheitlicher GC für alle Tasks — abgeschlossene Tasks jenseits des Alters oder der Obergrenze werden eingesammelt, laufende nie',
    taskRetentionMaxAge: 'Maximales Alter (Tage)',
    taskRetentionMaxCount: 'Maximale Anzahl Tasks',
    eventRetentionTitle: 'Ereignis-Aufbewahrung',
    eventRetentionSubtitle: 'Der GC des Journals — eine von den Tasks unabhängige Politik: der Task ist eine Warteschlange, das Ereignis ist Gedächtnis',
    eventRetentionMaxAge: 'Maximales Alter (Tage)',
    eventRetentionMaxCount: 'Maximal gespeicherte Ereignisse',
    spaceThresholdsTitle: 'Speicherplatz-Schwellen',
    spaceThresholdsSubtitle: 'Wann ein voller werdender Storage ins Journal (und in die Benachrichtigungen) gelangt',
    spaceLowPct: 'Warnung ab (% belegt)',
    spaceCriticalPct: 'Kritisch ab (% belegt)',
    spaceOrderError: 'Kritisch darf nicht unter der Warnung liegen',
    spaceThresholdsHint: 'Nur die Eintritte werden konfiguriert: den Austritt leitet die Engine ab, 5 Punkte unter jeder Schwelle, damit ein Storage auf der Linie nie zum Metronom wird',
    failoverReserveTitle: 'Failover-Reserve',
    failoverReserveSubtitle: 'Admission Control N+1 — RAM freigehalten, damit der Cluster seine Last nach dem Verlust von Knoten neu starten kann',
    failoverReserveTolerate: 'Zu tolerierende Knotenverluste',
    failoverReserveOff: '0 — Reserve aus: Kein Start wird je wegen Failover-Kapazität abgelehnt',
    failoverReserveOn: 'Ein Start, der die Reserve anbrechen würde, wird mit einem 412 abgelehnt, das die Zahlen erklärt',
    networkShapingTitle: 'Bandbreiten-Fairness',
    networkShapingSubtitle: 'Die drei Typologie-Gewichte des Shaping-Baums je Uplink — sie greifen nur bei Konkurrenz',
    networkShapingRest: 'Gewicht des Rests (Control Plane, Storage, Repliken)',
    networkShapingOverlay: 'Gewicht der Overlay-Netzwerke',
    networkShapingLiveMigration: 'Gewicht der Live Migration',
    networkShapingHint: 'Garantierter Anteil = Gewicht / Summe der drei (Standard 300 / 100 / 200, jeweils 1 bis 10000); auf einem freien Link darf jede Klasse die ganze Bandbreite nehmen',
    debugModeTitle: 'Debug-Modus',
    debugModeSubtitle:
      'Detaillierte Fehler in den allgemeinen GUI-Meldungen — um die wahre Ursache zu sehen, wenn eine „fehlgeschlagene“ Aktion in Wirklichkeit erfolgreich war',
    debugModeLabel: 'Debug-Modus aktiviert',
    debugModeOn: 'Allgemeine Fehlermeldungen hängen die zugrunde liegende Ursache an — interne Details für jeden Operator sichtbar',
    debugModeOffHint: 'Aus — allgemeine Fehlermeldungen bleiben allgemein, ohne interne Details',
    nodeDetailsAction: 'Knoten-Details',
    node: {
      docTitle: 'Knoten',
      notFound: 'Knoten nicht gefunden',
      tabOverview: 'Übersicht',
      tabStats: 'Statistiken',
      tabNetwork: 'Netzwerk',
      tabSettings: 'Lokale Einstellungen',
      identityTitle: 'Identität',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL-Port',
      revision: 'Config-Revision',
      versionsTitle: 'Beobachtete Versionen',
      heartbeatSubtitle: 'Der letzte Stand, den der Knoten über sich selbst gemeldet hat',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU-Modell',
      memoryTitle: 'Arbeitsspeicher',
      hugePagesTitle: 'Riesenseiten',
      hugePagesPool: '{size}: {free} frei von {total}',
      hugePagesNone: 'Kein Vorrat',
      hugePagesNoneHint: 'Der Knoten hat keine Riesenseiten reserviert: VMs, die welche anfordern, können hier nicht starten. Der Vorrat wird am Knoten deklariert, mit den Kernel-Parametern hugepagesz und hugepages oder durch Schreiben von nr_hugepages.',
      usageTitle: 'Aktuelle Nutzung',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'nicht beobachtet — kein frischer Messwert',
      statsNoData: 'Keine Daten im gewählten Zeitraum — die Serien des Knotens werden vom Knoten selbst erfasst und lokal ausgeliefert.',
      observedTitle: 'Beobachteter Zustand',
      observedSubtitle: 'Dienste und knotenlokale Assets, wie der Worker sie sieht'
    },
    editRolesTitle: 'Netzwerkrollen bearbeiten',
    memberNode: 'Knoten',
    memberIp: 'IP-Adresse',
    addMember: 'Mitglied hinzufügen',
    lmInherit: 'Die Management-Adressen verwenden',
    roleIpHint: 'Mitglieder hinzufügen und entfernen ist frei; die IP eines bestehenden Mitglieds direkt zu ändern wird abgelehnt — der Ablauf zur IP-Migration kommt in einem späteren Round.',
    roleError: 'Die Rollen konnten nicht aktualisiert werden',
    nodesTitle: 'Knoten',
    addNodeTitle: 'Knoten zum Cluster hinzufügen',
    addNode: 'Knoten hinzufügen',
    addNodeError: 'Der Knoten konnte nicht vorregistriert werden',
    nodeName: 'Knotenname',
    nodeNameHint: 'muss mit dem bei der Installation gewählten Namen übereinstimmen',
    nodeIp: 'Management-IP',
    colName: 'Name',
    colPhase: 'Phase',
    colServices: 'Dienste',
    colWatermark: 'Watermark',
    colLastSeen: 'Letzter Kontakt',
    colUps: 'USV',
    upsCordonChip: 'USV-Sperre',
    upsCordonTip: 'Der Knoten hat sich aufgrund seiner USV-Fakten selbst verurteilt ({time}): er hebt die Sperre selbst auf, sobald das Netz stabil und die Batterie geladen ist',
    upsUnreachable: 'USV nicht erreichbar',
    upsOnBattery: 'Auf Batterie',
    upsOnLine: 'Am Netz',
    upsLowBattery: 'Batterie leer',
    upsNoEstimateChip: 'Restlaufzeit nicht geschätzt',
    upsNoEstimateTip: 'Die USV veröffentlicht keine Restlaufzeit: der Knoten wird nur über das LB-Flag (Batterie leer) der USV verurteilt — battery.runtime.low / LB an der USV selbst einstellen',
    upsLaneTip: 'USV-Abschaltpfad seit {since}: verurteilt durch {by}',
    upsUnit: 'Einheit',
    upsStatus: 'NUT-Status',
    upsLoad: 'Last',
    upsOnBatterySince: 'auf Batterie seit',
    upsOnLineSince: 'am Netz seit',
    upsError: 'Fehler',
    upsObservedAt: 'beobachtet',
    upsNone: 'keine USV-Einheit versorgt diesen Knoten',
    upsBy: {
      runtime: 'Restlaufzeit unter Schwelle',
      lowBattery: 'LB-Flag der USV',
    },
    upsLane: {
      evacuate: 'Evakuierung',
      local: 'Abschaltung vor Ort',
    },
    upsPhase: {
      draining: 'Drain',
      stoppingGuests: 'Gäste werden gestoppt',
      stoppingServices: 'Dienste werden gestoppt',
      poweredOff: 'ausgeschaltet',
    },
    upsTitle: 'USV (NUT)',
    upsSubtitle: 'USV-Einheiten und Schwellen: Knoten verurteilt bei Restlaufzeit ≤ Schwelle oder LB-Flag (immer beachtet), Wiederanlauf mit Hysterese',
    upsRuntimeThreshold: 'Restlaufzeit-Schwelle (s)',
    upsRuntimeThresholdHint: 'Auf Batterie mit geschätzter Restlaufzeit ≤ Schwelle fährt der Knoten geordnet herunter (Standard 300)',
    upsResumeStable: 'Netz stabil für (s)',
    upsResumeStableHint: 'Wiederanlauf nur bei durchgehendem Netz seit mindestens so vielen Sekunden (Standard 60)',
    upsResumeCharge: 'Mindestladung beim Wiederanlauf (%)',
    upsResumeChargeHint: 'Und Batterie mindestens auf diesen Prozentsatz geladen (Standard 25)',
    upsPolicyNote: 'Das LB-Flag (Batterie leer) der USV verurteilt immer und lässt sich nicht abschalten; eine Schwelle auf die Zeit auf Batterie gibt es nicht. Jede Einheit kann die drei Zahlen überschreiben.',
    upsUnitNew: 'neue Einheit',
    upsUnitSelectors: '{n} Tag-Selektor(en) (nur CLI)',
    upsUnitName: 'Name der Einheit',
    upsUnitMode: 'Modus',
    upsModeExternal: 'extern (fremder upsd)',
    upsModeManaged: 'verwaltet (USV an einem Knoten angeschlossen)',
    upsUnitUpsname: 'NUT-Name (upsname)',
    upsUnitHost: 'upsd-Host',
    upsUnitAttachedNode: 'Angeschlossener Knoten',
    upsUnitDriver: 'NUT-Treiber',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Gerät des Treibers',
    upsUnitDeviceHint: 'die Zeile port= in ups.conf: leer = auto',
    upsUnitPort: 'upsd-Port',
    upsUnitServedNodes: 'Versorgte Knoten',
    upsUnitServedNodesHint: 'Knotennamen durch Kommas getrennt (Tag-Selektoren über die CLI)',
    upsUnitOverrideHint: 'leer = Cluster-Standard',
    upsUnitAdd: 'Einheit hinzufügen',
    unreachableSince: 'Nicht erreichbar — letzter Heartbeat {time}',
    overlaysChip: 'Overlays',
    overlaysBehind: 'Die Overlay-Dataplane hat die aktuelle Overlay-Konfiguration noch nicht umgesetzt',
    overlaysError: 'Letzter Overlay-Abgleichlauf fehlgeschlagen: {error}',
    storeChip: 'Store',
    phase: {
      'pending-join': 'Join ausstehend',
      'joining': 'Im Beitritt',
      'member': 'Mitglied'
    },
    tokenTitle: 'Join-Token',
    tokenOnce: 'Wird nur jetzt angezeigt — kopieren Sie ihn sofort, er ist nie wieder lesbar',
    copy: 'Kopieren',
    copied: 'Kopiert',
    close: 'Schließen',
    revokeTitle: 'Vorregistrierung widerrufen',
    revoke: 'Widerrufen',
    revokeError: 'Die Registrierung konnte nicht widerrufen werden',
    promote: 'Zum Store-Member befördern',
    demote: 'Store-Member-Rolle entfernen',
    troubleshoot: 'Problembehandlung',
    promoteTitle: 'Zum Store-Member befördern',
    demoteTitle: 'Store-Member-Rolle entfernen',
    promoteHint: 'Der Knoten tritt dem Quorum der YugabyteDB-Master bei. Echte HA braucht drei Store-Member.',
    demoteHint: 'Der Knoten verlässt das Master-Quorum und stoppt seine Store-Dienste.',
    storeError: 'Die Store-Member-Änderung wurde abgelehnt',
    attest: 'Als ausgeschaltet attestieren…',
    attestTitle: 'Knoten als ausgeschaltet attestieren',
    attestSubmit: 'Als ausgeschaltet attestieren',
    attestConfirm: 'Sie erklären diesen Knoten für ausgeschaltet, auf eigenes Risiko: Einen in Wirklichkeit lebendigen Knoten zu attestieren riskiert doppelt laufende VMs. Seine Tasks werden auf fehlgeschlagen gesetzt und die Authorities seiner VMs werden übertragbar.',
    attestError: 'Die Attestierung wurde abgelehnt',
    attestedChip: 'attestiert ausgeschaltet',
    maintenanceChip: 'Wartung',
    guestToolsChip: 'TVirt Guest Tools (knotenlokales ISO-Asset)',
    maintenanceEnter: 'Wartung aktivieren',
    maintenanceExit: 'Wartung deaktivieren',
    maintenanceEnterTitle: 'Wartung aktivieren',
    maintenanceExitTitle: 'Wartung deaktivieren',
    maintenanceEnterSubmit: 'Wartung aktivieren',
    maintenanceExitSubmit: 'Wartung deaktivieren',
    maintenanceEnterConfirm: 'Der Knoten wird abgesperrt und geleert: die Netzwerkdienste und App-Instanzen, deren Authority er hält, werden übertragen (Instanzen kalt: hier gestoppt und gemäht, auf dem Zielknoten neu erzeugt — Ausfallzeit), laufende VMs werden live migriert, wo möglich, sonst sauber gestoppt, laufende Aufgaben enden, neue Arbeit wartet, und gestoppte VMs verlieren ihre Authority — Proximity platziert sie beim nächsten Start neu. Nichts kehrt am Ende der Wartung von selbst zurück.',
    maintenanceExitConfirm: 'Der Knoten nimmt die Arbeit wieder auf und Proximity zieht ihn wieder für die Platzierung in Betracht. Die VMs kehren erst zurück, wenn sie gestartet werden.',
    maintenanceError: 'Die Wartungsanfrage wurde abgelehnt',
    maintenancePlanTitle: 'Evakuierungsplan',
    maintenancePlanLoading: 'Der Evakuierungsplan wird berechnet…',
    maintenancePlanError: 'Der Evakuierungsplan konnte nicht geladen werden — der Drain migriert trotzdem wo möglich und stoppt den Rest.',
    maintenancePlanEmpty: 'Auf diesem Knoten ist nichts zu evakuieren — kein aktiver Netzwerkdienst, keine laufend gewollte App-Instanz, keine laufende VM.',
    maintenancePlanSummary: '{migrate} Objekte migrieren (VMs, Netzwerkdienste, App-Instanzen), {stop} werden gestoppt oder bleiben, wo sie sind.',
    maintenancePlanReserve_ok: 'Failover-Reserve nach dem Leeren: intakt — es bleiben {headroom} GiB startbar, während der Verlust von {n} Knoten toleriert wird.',
    maintenancePlanReserve_eroded: 'Failover-Reserve nach dem Leeren: fast aufgebraucht — nur noch {headroom} GiB der {reserve} GiB übrig, die für {n} Knotenausfall/-ausfälle freigehalten werden.',
    maintenancePlanReserve_exhausted: 'Failover-Reserve nach dem Leeren: ERSCHÖPFT — es fehlen {headroom} GiB der {reserve} GiB, die nötig sind, um {n} Knotenausfall/-ausfälle zu tolerieren. Solange dieser Knoten fehlt, werden neue VM-Starts abgelehnt.',
    maintenancePlanReserve_unknown: 'Failover-Reserve nach dem Leeren: nicht berechenbar — kein verbleibender Knoten hat seinen Arbeitsspeicher gemeldet.',
    maintenancePlanReserveHugePages: 'Riesenseiten zu {size} nach dem Leeren — frei: {free} von {capacity}, als Reserve benötigt: {reserve}.',
    maintenancePlanActionMigrate: 'migriert',
    maintenancePlanActionMigrateWarning: 'migriert (Soft-Regel verletzt)',
    maintenancePlanActionStop: 'stoppt',
    maintenancePlanActionBlocked: 'blockiert',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'Netzwerkdienst',
    maintenancePlanKindApp: 'App-Instanz',
    maintenancePlanColdMove: 'Kalter Umzug: der Pod wird hier gestoppt und gemäht und vom Worker des Zielknotens neu erzeugt — Ausfallzeit bis zum nächsten Pass des Ziel-Workers.',
    caFingerprint: 'Fingerprint der Cluster-CA',
    staleChip: 'veraltet',
    troubleshootTitle: 'Store-Problembehandlung',
    restartStore: 'Store-Dienste neu starten',
    restartHint: 'Wenn der Store zickt, starten Sie seine Dienste neu. Fortgeschritten — mit Vorsicht verwenden.',
    restartQueued: 'Neustart-Task eingereiht',
    restartError: 'Die Dienste konnten nicht neu gestartet werden',
    svcActive: 'aktiv',
    svcWanted: 'gewollt, nicht aktiv',
    svcStopped: 'gestoppt',
    noServices: 'Keine Dienste gemeldet'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Das GPU-Inventar des gesamten Clusters, gruppiert nach Modell — die beobachteten Karten je Knoten, mit den markierten Registrierungen und ihren Tags',
    usbTitle: 'USB-Ressourcen',
    usbSubtitle: 'Das USB-Inventar des gesamten Clusters, gruppiert nach Modell — die beobachteten Geräte je Knoten, mit den Registrierungen beider Modelle (je Gerät, je Port) und ihren Tags',
    markedChip: '{n} von TVirt nutzbar',
    orphanChipGpu: '{n} verwaist',
    orphanChipUsb: '{n} verwaist',
    colNode: 'Knoten',
    colRegistration: 'Registrierung',
      noRegsHint: 'Keine Registrierung — das Gerät wird im Dialog des Knotens als "nutzbar durch TVirt" markiert (Knoten › Knoten › Einstellungen).',
      colDevice: 'Gerät',
      colObserved: 'Beobachtet',
      colRegs: 'Registrierungen',
      regsNone: 'keine',
      colPci: 'PCIe-Adresse',
      colIdentity: 'Identität / Port',
      colClasses: 'Klassen (Tags)',
      colActions: 'Aktionen',
      manageOnNode: 'Auf Knoten {node} verwalten (die Markierung lebt im Dialog des Knotens)',
      introTitle: 'Das Cluster-Inventar der von TVirt© nutzbaren USB- und PCIe-Geräte.',
      introStep1: '1. Die Knoten entdecken ihre GPUs und USB-Geräte selbst (Bestandsaufnahme im Heartbeat).',
      introStep2: '2. Ein Gerät wird im Dialog des KNOTENS als "nutzbar durch TVirt" markiert (Knoten › Knoten › Einstellungen) — die Markierung bindet es an vfio und registriert es hier.',
      introStep3: '3. Hier geben Sie den Registrierungen ihre KLASSEN über Tags (z. B. gpu_class=compute): Die Anforderungen der VMs verlangen eine Klasse, und der Scheduler wählt einen Knoten mit einem freien passenden Gerät.',
    colMode: 'Modus',
    colState: 'Zustand',
    colNotes: 'Notizen',
    colTags: 'Tags',
    modeDevice: 'je Gerät',
    modePort: 'je Port',
    usable: 'nutzbar',
    orphanGpu: 'verwaist',
    orphanUsb: 'verwaist',
    hubChip: 'Hub',
    orphanPortsTitle: 'Port-Registrierungen ohne angeschlossenes Gerät — schließen Sie ein Gerät wieder an oder entfernen Sie die Markierung am Knoten',
    gpusEmpty: 'Noch keine GPU auf irgendeinem Knoten beobachtet',
    usbEmpty: 'Noch kein USB-Gerät auf irgendeinem Knoten beobachtet'
  },
  settings: {
    passwordMinLength: 'Minimale Passwortlänge',
    sessionIdle: 'Inaktivitäts-Timeout der Sitzung (Minuten)',
    lockoutThreshold: 'Sperre nach Fehlversuchen',
    lockoutDuration: 'Sperrdauer (Minuten)',
    keyboardLayout: 'Tastaturlayout',
    keyboardLayoutHint: 'z. B. it, en-us — leer für den QEMU-Default',
    syslogEndpoint: 'Syslog-Endpoint',
    syslogEndpointHint: 'host:port — leer, um die Weiterleitung zu deaktivieren',
    syslogTls: 'TLS',
    maxQueued: 'Maximale Tasks in der Warteschlange',
    concurrency: 'Parallelität des Workers',
    concurrencyHint: 'Vom Worker live übernommen',
    notesTitle: 'Notizen',
    save: 'Speichern',
    saved: 'Einstellungen gespeichert',
    saveError: 'Die Einstellungen konnten nicht gespeichert werden'
  },
  localSettings: {
    derivedChip: 'abgeleitet',
    derivedTip: 'Dieses Device GEHÖRT der Fabric-Ableitung (H2): der Editor fasst es nicht an — Fabric (oder Verkabelung) ändern und neu anwenden, oder es unten zurücknehmen.',
    takeOwnership: 'Besitz übernehmen',
    takeOwnershipTitle: 'Besitz übernehmen (take-ownership)',
    takeOwnershipConfirm: '{name} verlässt den Fabric-Block und wird wieder ein MANUELLES Device dieses Editors. Der Knoten wird abgewichen, und der nächste Ableitungs-Apply lehnt darauf ab (manualConflict), bis Sie es umbenennen oder entfernen — oder die Fabric korrigieren.',
    nodeSettingsTitle: 'Knoten-Einstellungen',
    nodeSettingsSubtitle: 'Was dieser Knoten durchsetzt — Task-Warteschlange, Konsole, Log-Weiterleitung — plus seine Tags und Notizen',
    baseTitle: 'Host-Reservierungen (TVirt Proximity)',
    baseSubtitle: 'CPU und RAM, die dem Betriebssystem des Hosts vorbehalten sind — die Eingaben der empirischen Kapazität, nach der Proximity die VMs platziert',
    baseMemory: 'Basis-RAM (MiB)',
    baseMemoryHint: 'Beobachtetes Gesamt: {total} MiB. Nutzbar für VMs = Gesamt − Basis − RAM der hier platzierten eingeschalteten VMs.',
    baseMemoryHintNoTotal: 'Nutzbar für VMs = beobachtetes Gesamt − Basis − RAM der hier platzierten eingeschalteten VMs.',
    baseCpu: 'Basis-CPU-Kerne',
    baseCpuHint: 'Beobachtete logische CPUs: {total}. Nur als Ranking-Gewicht verwendet — vCPU-Overcommit ist normal.',
    baseCpuHintNoTotal: 'Nur als Ranking-Gewicht verwendet — vCPU-Overcommit ist normal.',
    baseHint: 'RAM ist das harte Zulassungs-Gate: Eine VM, die nicht in den nutzbaren RAM passt, wird mit einem sprechenden Fehler abgelehnt. Erhöhen Sie die Basis auf Hosts, die Store-Mitglieder oder Ceph-Daemons beherbergen.',
    placementTitle: 'Physische Platzierung',
    placementSubtitle: 'Wo dieser Server physisch steht — einmal deklariert, was immer er bedient',
    placementHint: 'Die Platzierung steuert die CRUSH-Hierarchie jedes Ceph-Clusters mit einem OSD auf diesem Server: Das Speichern einer Änderung richtet ihre Maps per Task neu aus (host → rack → … → root). Partielle Deklarationen sind legal — leere Ebenen kollabieren einfach. Die Namen werden über die ganze Map geteilt: Zwei Server im selben Rack deklarieren denselben Rack-Namen.',
    placementNameInvalid: 'DNS-sicherer Name (Kleinbuchstaben, Ziffern, Bindestriche)',
    placementEmpty: 'Leer = nicht deklariert',
    placementLevel: {
      chassis: 'Chassis',
      rack: 'Rack',
      row: 'Reihe',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Raum',
      datacenter: 'Datacenter',
      zone: 'Zone',
      region: 'Region'
    },
    cablingTitle: 'Verkabelung',
    cablingSubtitle: 'An welchem Switch-Port jede Schnittstelle hängt — die Deklaration lebt auf dem Knoten (Annex O.9)',
    cablingHint: 'Ein Kabel je NIC, ein Kabel je Port über die ganze Flotte (die API lehnt ab und nennt den Inhaber). Die Verkabelung zu einem LAGG-Member-Port ist legal — das ist der Bond-Fall: Die künftige Ableitung rendert ihn als LACP.',
    cablingInterface: 'Schnittstelle',
    cablingNotCabled: '— nicht verkabelt —',
    cablingNoInterfaces: 'Noch keine Netzwerkschnittstelle beobachtet',
    disksTitle: 'Festplatten',
    disksSubtitle: 'Beobachtete Blockgeräte — ein Scan je Abgleichlauf; markieren Sie hier die als Ceph-OSDs nutzbaren Festplatten (N.15: Die Eignung ist explizit)',
    colDataDisk: 'Datenfestplatte',
    dataDisksHint: 'Ein Gerät anzuhaken erklärt es für nutzbar als OSD; die Seriennummer ist sein Identitäts-Pin — von der Hardware kopiert, wenn das Gerät eine meldet, andernfalls geprägt (tvirt-…). Der Ceph-Registrierungsdialog bietet nur deklarierte Festplatten an.',
    diskDeclaredSerial: 'deklariert',
    diskNotObserved: 'deklariert, aber nicht beobachtet — hängen Sie das Gerät wieder an oder entfernen Sie den Haken',
    noDisks: 'Noch keine Blockgeräte beobachtet',
    colSerial: 'Seriennummer',
    colModel: 'Modell',
    colSize: 'Größe (GiB)',
    colDiskType: 'Typ',
    colInUse: 'In Benutzung',
    colObservedAt: 'Beobachtet',
    diskInUse: 'in Benutzung',
    diskFree: 'frei',
    diskMounted: 'gemountet',
    diskPartitions: 'Partitionen',
    passthroughTitle: 'Passthrough-Geräte',
    passthroughSubtitle: 'Beobachtete GPUs und USB-Geräte — markieren Sie hier, was TVirt an VMs durchreichen darf; die Markierung registriert die Identität des Geräts (Round U1+G1)',
    passthroughHint: 'Die Markierung registriert das Gerät (eine stabile Id — das Ziel von Tags und Klassenanforderungen). Bei einer markierten GPU wird die GESAMTE IOMMU-Gruppe auf einen Schlag an vfio-pci gebunden — sie verlässt den Host sofort; das Entmarkieren bindet den nativen Treiber wieder. Für USB gibt es beide ratifizierten Modelle: je Gerät (Vendor+Produkt, wo immer es eingesteckt ist) und je physischem Port (die VM bekommt, was auch immer dort steckt). USB bindet nie bei der Markierung — der Attach passiert zur Laufzeit der VM.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Nutzbar durch TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI-Adresse',
    colDriver: 'Treiber',
    colVerdict: 'Befund',
    gpuEligible: 'Geeignet',
    gpuIneligible: 'Nicht geeignet',
    gpuReason: {
      'no-iommu': 'IOMMU auf dem Host nicht aktiv',
      'group-spans-slots': 'IOMMU-Gruppe nicht isoliert: sie erstreckt sich über weitere Slots',
      'multiple-display': 'IOMMU-Gruppe nicht isoliert: mehr als eine Grafikfunktion',
      'foreign-function': 'IOMMU-Gruppe nicht isoliert: sie enthält eine fremde Funktion'
    },
    vfioNotReady: 'IOMMU ist auf diesem Host nicht aktiv: Keine GPU ist geeignet, bis die Host-Plattform es aktiviert (OEM-ISO) — TVirt fasst Kernel-Args zur Laufzeit nie an.',
    vfioMissingKernelArg: 'IOMMU ist auf diesem Host nicht aktiv: Die Firmware meldet VT-d/AMD-Vi (ACPI-Tabelle DMAR/IVRS vorhanden), aber das Kernel-Arg fehlt — fügen Sie intel_iommu=on (Intel) hinzu oder entfernen Sie amd_iommu=off (AMD) von der Kernel-Command-Line und starten Sie neu. TVirt fasst Kernel-Args zur Laufzeit nie an.',
    vfioFirmwareDisabled: 'IOMMU ist auf diesem Host nicht aktiv: VT-d/AMD-Vi ist in der Firmware deaktiviert (keine ACPI-Tabelle DMAR/IVRS) oder die CPU unterstützt es nicht — aktivieren Sie es im Firmware-Setup, kein Kernel-Arg kann es einschalten. TVirt fasst den Host zur Laufzeit nie an.',
    gpuBindError: 'vfio-pci-Bind auf {address} fehlgeschlagen: {error}',
    firewallBridgesTitle: 'Firewall auf nicht verwalteten Bridges',
    firewallBridgesSubtitle: 'Die von Hand gebauten Bridges auf diesem Knoten, deren Setup den von TVirt gerenderten Firewall-Chains auf angeschlossenen Gast-NICs zustimmt',
    firewallBridgesHint: 'TVirt rührt die fremde Bridge nie an — die Chain ankert auf dem tap/veth, das immer TVirt gehört. Die Liste ist ein Zustimmungs-Gate: default-deny und anti-spoof können brechen, was ein manuelles Setup erwartet — eine NIC mit Firewall auf einer nicht verwalteten Bridge, die hier NICHT gelistet ist, wird deshalb mit einem sprechenden Fehler abgelehnt.',
    firewallBridgesEmpty: 'Keine nicht verwaltete Bridge stimmt auf diesem Knoten den von TVirt gerenderten Firewall-Chains zu.',
    firewallBridgeAdd: 'Bridge hinzufügen',
    firewallBridgeInvalid: 'Kein Linux-Interface-Name (1-15 Zeichen, ohne Slash und Leerzeichen)',
    firewallBridgeDuplicate: 'Name bereits gelistet',
    colMarkDevice: 'Je Gerät',
    colMarkPort: 'Je Port',
    usbHub: 'Hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'verwaist — registriert, aber nicht mehr erkannt: schließen Sie es wieder an oder entfernen Sie die Markierung',
    noGpus: 'Noch keine GPU beobachtet',
    noUsb: 'Noch keine USB-Geräte beobachtet',
    networkGeneration: 'Netzwerk-Generation',
    applied: 'Angewendet',
    converged: 'konvergiert',
    behind: 'im Rückstand — {m} / {n}',
    notConfigured: 'nicht konfiguriert',
    rollbackBody: 'Anwendung der Generation {gen} fehlgeschlagen: {error}',
    rolledBackChip: 'Rollback ausgeführt',
    nicsTitle: 'NICs',
    nicsSubtitle:
      'Das Register der verwalteten NICs — die Registrierung IST die Verwaltungserklärung: Eine registrierte NIC ohne Konfiguration wird nicht angefasst (clear-if erklärt sie explizit für sauber), ein nicht registriertes Gerät wird nie angefasst',
    addNic: 'NIC registrieren',
    addNicTitle: 'NIC registrieren (add-nic)',
    delNic: 'Verwaltung beenden',
    delNicTitle: 'Verwaltung beenden (del-nic)',
    delNicConfirm:
      'Die Verwaltung von {name} endet: Der Registereintrag und seine Konfiguration werden gelöscht und das TVirt-Profil entfernt — das Gerät selbst bleibt so, wie Linux es hat.',
    nicName: 'Gerätename',
    nicMac: 'Permanente MAC-Adresse',
    nicMacHint: 'die permanente Hardware-MAC — die vom TVirt Server Installer gesetzte stabile Identität',
    colObserved: 'Beobachtet',
    nicObserved: 'beobachtet',
    nicNotObserved: 'nicht beobachtet',
    nicMacMismatch: 'MAC weicht ab — beobachtet {mac}',
    noNics: 'Keine NIC registriert — registrieren Sie ein Gerät, um es zu verwalten',
    noManagedDevices: 'Keine verwalteten Geräte — registrieren Sie zuerst eine NIC, alles baut auf dem Register auf',
    inventoryTitle: 'Beobachtete Geräte',
    inventorySubtitle: 'Bei jedem Abgleichlauf vom Knoten-Worker aufgefrischt — die Validierung prüft Gerätenamen gegen dieses Inventar',
    colDevice: 'Gerät',
    colType: 'Typ',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Geschwindigkeit',
    colTopology: 'Topologie',
    colMtu: 'MTU',
    colAddresses: 'Adressen',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP aggregiert nicht',
    noInventory: 'Noch keine Geräte gemeldet',
    interfacesTitle: 'Schnittstellen',
    interfacesSubtitle:
      'L3-Konfiguration der registrierten NICs und der deklarierten logischen Geräte — set-if ersetzt den ganzen Block, edit-if passt Eigenschaften an, clear-if leert ihn (explizite Sauberkeit)',
    colConfig: 'Gewünschte Konfiguration',
    clean: 'sauber',
    setIf: 'Adressierung bearbeiten',
    setIfTitle: 'Adressierung bearbeiten (set-if)',
    editIf: 'Eigenschaften bearbeiten',
    editIfTitle: 'Eigenschaften bearbeiten (edit-if)',
    clearIf: 'Konfiguration leeren',
    clearIfTitle: 'Konfiguration leeren (clear-if)',
    clearIfConfirm: 'Die Konfiguration der Schnittstelle wird geleert. Eine saubere Schnittstelle ist die Voraussetzung, um sie als Bond-/Bridge-Member oder VLAN-Parent einzuspannen.',
    ip4Mode: 'IPv4-Modus',
    ip6Mode: 'IPv6-Modus',
    modeUnconfigured: 'Nicht konfiguriert',
    modeStatic: 'Statisch',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4-Adressen',
    ip6Addresses: 'IPv6-Adressen',
    addressesHint: 'CIDR, kommagetrennt',
    gw4: 'IPv4-Gateway',
    gw6: 'IPv6-Gateway',
    dns: 'DNS-Server',
    dnsHint: 'kommagetrennt — leer löscht DNS (set-if ersetzt den Block)',
    routes4: 'Statische IPv4-Routen',
    routes6: 'Statische IPv6-Routen',
    routeTo: 'Ziel (CIDR)',
    routeVia: 'Via',
    addRoute: 'Route hinzufügen',
    routesChip: 'Routen',
    mtu: 'MTU',
    mtuHint: 'leer = Treiber-Default',
    vlansTitle: 'VLANs',
    addVlan: 'VLAN hinzufügen',
    addVlanTitle: 'VLAN hinzufügen (add-vlan)',
    delVlanTitle: 'VLAN löschen (del-vlan)',
    vlanParent: 'Parent-Schnittstelle',
    vlanId: 'VLAN-ID',
    vlanPreview: 'Gerätename',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Keine VLANs deklariert',
    bondsTitle: 'Bonds',
    addBond: 'Bond hinzufügen',
    addBondTitle: 'Bond hinzufügen (add-bond)',
    editBondTitle: 'Bond bearbeiten',
    editBond: 'Bond speichern',
    delBondTitle: 'Bond löschen (del-bond)',
    bondName: 'Bond-Name',
    members: 'Mitglieder',
    membersHint: 'die Mitglieder müssen saubere Schnittstellen sein (ohne L3-Konfiguration)',
    bondMode: 'Modus',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primäres Mitglied',
    rate: 'LACP-Rate',
    hash: 'Hash-Richtlinie beim Senden',
    colMembers: 'Mitglieder',
    colMode: 'Modus',
    noBonds: 'Keine Bonds deklariert',
    bridgesTitle: 'Bridges',
    addBridge: 'Bridge hinzufügen',
    addBridgeTitle: 'Bridge hinzufügen (add-bridge)',
    editBridgeTitle: 'Bridge bearbeiten',
    editBridge: 'Bridge speichern',
    delBridgeTitle: 'Bridge löschen (del-bridge)',
    bridgeName: 'Bridge-Name',
    stp: 'STP',
    stpOn: 'STP an',
    stpOff: 'STP aus',
    colStp: 'STP',
    noBridges: 'Keine Bridges deklariert',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Hostname setzen',
    setHostnameTitle: 'Hostname setzen (set-hostname)',
    hostnameHint: 'Nur OS-Identität — der Knotenname im Cluster wird nicht angefasst',
    notSet: 'nicht gesetzt',
    staticHostsTitle: 'Statische Host-Einträge',
    addStaticHost: 'Eintrag hinzufügen',
    addStaticHostTitle: 'Statischen Host-Eintrag hinzufügen',
    delStaticHostTitle: 'Statischen Host-Eintrag löschen',
    hostIp: 'IP-Adresse',
    hostNames: 'Namen',
    hostNamesHint: 'durch Komma oder Leerzeichen getrennt',
    colIp: 'IP',
    colNames: 'Namen',
    noStaticHosts: 'Keine statischen Host-Einträge',
    delConfirm: 'Entfernung von {name} aus dem gewünschten Dokument — der Knoten-Worker konvergiert mit einem NetworkManager-Checkpoint und automatischem Rollback.',
    remove: 'Entfernen',
    opError: 'Die Netzwerkoperation wurde abgelehnt'
  }
}
